<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t(type) }} {{ $t('entrepot') }}</v-toolbar-title>
      <v-radio-group
        v-model="type"
        class="mt-6"
        row
      >
        <v-radio
          :label="$t('tempReceipt')"
          value="tempReceipt"
          :disabled="(id && type != 'tempReceipt' || type != 'receipt' && type != 'tempReceipt' ? true : false)"
        />
        <v-radio
          :label="$t('receipt')"
          value="receipt"
          :disabled="(id && type != 'tempReceipt' || type != 'receipt' && type != 'tempReceipt' ? true : false)"
        />
        <v-radio
          :label="$t('remittance')"
          value="remittance"
          :disabled="(id || type != 'remittance' ? true : false)"
        />
        <v-radio
          :label="$t('useRemittance')"
          value="useRemittance"
          :disabled="(id || type != 'useRemittance' ? true : false)"
        />
        <v-radio
          :label="$t('transferRemittance')"
          value="transferRemittance"
          :disabled="(id || type != 'transferRemittance' ? true : false)"
        />
        <v-radio
          :label="$t('transferProductStock')"
          value="transferProductStock"
          :disabled="(id || type != 'transferProductStock' ? true : false)"
        />
        <v-radio
          :label="$t('warehouseHandling')"
          value="warehouseHandling"
          :disabled="(id || type != 'warehouseHandling' ? true : false)"
        />
      </v-radio-group>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f2']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="addRow()"
            v-on="on"
            @click="addRow()"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('newRow') }} (f2)</span>
      </v-tooltip>
      <v-tooltip
        v-if="selected.length > 0"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon
              color="pink"
              style="font-size: 22px"
            >
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('remove') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showSelect = !showSelect"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              {{ (showSelect ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked-outline') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('select-row') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( type + 'List' )"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('list') }} {{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs>
        <v-tab style="height: 50px">
          {{ $t('public-information') }}
        </v-tab>
        <v-tab
          :disabled="documentPermmission"
        >
          {{ $t('documents') }}
        </v-tab>
        <v-tab-item>
          <v-row class="mx-0 my-2">
            <v-col
              class="mb-0 pb-0 "
              cols="12"
              md="3"
              sm="3"
              style="height: 55px"
            >
              <autocomplete
                ref="refEntrepot"
                v-model="entrepot"
                :rules="[v => !!v || $t('is-required')]"
                :title="$t('entrepot')"
                type="entrepot"
                :set-init="true"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="3"
            >
              <template>
                <v-text-field
                  id="from"
                  v-model="date"
                  :label="$t('date')"
                  :rules="[v => !!v || $t('is-required')]"
                  clear-icon="flaticon2-close-cross"
                  outlined
                  dense
                  clearable
                />

                <date-picker
                  v-model="date"
                  element="from"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :min="$store.state.startDate"
                  :max="$store.state.endDate"
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </template>
            </v-col>
            <v-col
              class="mb-0 pb-0 "
              cols="12"
              md="3"
              sm="3"
              style="height: 55px"
            >
              <status
                v-model="status"
                :hideconfig="true"
                :type="type"
                :value="status"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <tag
                v-model="tag"
                :solo="false"
                :input="tag"
                :height="25"
              />
            </v-col>
            <v-col
              v-if="type == 'receipt' || type == 'remittance'|| type == 'tempReceipt'"
              class="px-3 xs"
              cols="12"
              md="3"
              sm="3"
            >
              <autocomplete
                ref="refRelations"
                v-model="relations"
                :value="relations"
                :data="JSON.stringify({
                        refId : null,
                        currency_id : null,
                        checkCount : true,
                        type: type
                })"
                :title="$t('relative-document')"
                type="getInvoiceForEntrepot"
              />
            </v-col>
            <v-col
              v-if="type === 'useRemittance'"
              class="px-3 xs"
              cols="12"
              md="3"
              sm="3"
            >
              <autocomplete
                ref="refDetail"
                v-model="detail"
                :rules="[v => !!v || $t('is-required')]"
                :title="$t('detail')"
                type="detail"
              />
            </v-col>
            <v-col
              v-show="type === 'transferRemittance' || type === 'transferProductStock'"
              class="mb-0 pb-0 "
              cols="12"
              md="3"
              sm="3"
              style="height: 55px"
            >
              <autocomplete
                ref="refRecipientEntrepot"
                v-model="recipientEntrepot"
                :rules="[v => !!v || $t('is-required')]"
                :title="$t('recipientEntrepot')"
                type="entrepot"
                :set-init="true"
              />
            </v-col>
            <v-col
              class="mb-0 pb-0 "
              cols="12"
              md="3"
              sm="3"
              style="height: 55px"
            >
              <aicomplete
                v-model="branch"
                :set-init="true"
                title="branch"
                type="branch"
                :val="branch"
                :new-btn="true"
              />
            </v-col>
            <v-col
              class="pb-0 pt-0"
              cols="6"
            >
              <description
                ref="refContent"
                v-model="content"
                class="mt-1 mb-3"
                :outlined="true"
                type="purchase"
              />
            </v-col>
          </v-row>
          <v-col
            cols="12"
            class="px-2 py-0 "
          >
            <v-data-table
              v-if="headers"
              :height="tableHeight"
              fixed-header
              v-model="selected"
              :headers="showHeaders"
              :items="items"
              :options.sync="tableOptions"
              :server-items-length="totalItems"
              :loading="loading"
              multi-sort
              dense
              :show-select="showSelect"
              hide-default-footer
              item-key="id"
            >
              <template v-slot:item.actions="{ item }">
                <v-menu
                  offset-y
                >
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      icon
                      v-on="on"
                    >
                      <v-icon
                        medium
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-if="item.product && costManagament && (type == 'receipt' || type == 'tempReceipt')"
                      link
                      @click="openCostDialog(item)"
                    >
                      <v-list-item-icon>
                        <v-icon>
                          mdi-cash-minus
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('cost')" />
                    </v-list-item>
                    <v-list-item
                      v-if="costManagament && (type == 'receipt' || type == 'tempReceipt')"
                      link
                      @click="openCostListDialog(item)"
                    >
                      <v-list-item-icon>
                        <v-icon>
                          mdi-format-list-bulleted-square
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('costs')" />
                    </v-list-item>
                    <v-list-item
                      link
                      @click="openDeleteDialog(item)"
                    >
                      <v-list-item-icon>
                        <v-icon color="pink">
                          mdi-trash-can-outline
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('remove')" />
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:item.row="{ item }">
                {{ parseInt(items.indexOf(item))+ parseInt(from) }}
              </template>
              <template v-slot:item.product="{ item }">
                <autocomplete
                  :ref="'refProduct' + parseInt(items.indexOf(item))"
                  v-model="item.product"
                  :value="item.product"
                  class="mb-3"
                  :rules="[v => !!v || $t('is-required')]"
                  type="product"
                  :disabled="!entrepot"
                  :data="JSON.stringify({entrepot:(entrepot ? entrepot.id : null), getCosts: (type == 'warehouseHandling' ? true : false)})"
                  :new-btn="true"
                  @input="checkProduct(item, parseInt(items.indexOf(item)))"
                />
              </template>
              <template v-slot:item.to_product="{ item }">
                <autocomplete
                  :ref="'refToProduct' + parseInt(items.indexOf(item))"
                  v-model="item.to_product"
                  :value="item.to_product"
                  class="mb-3"
                  :rules="[v => !!v || $t('is-required')]"
                  type="product"
                  :disabled="!entrepot"
                  :new-btn="true"
                />
              </template>
              <template v-slot:item.stock="{ item }">
                {{ (item.product && item.product.stock ? $numberFormat(item.product.stock.count) : 0) }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge
                      color="error"
                      overlap
                      :content="item.cost.length"
                      :value="item.cost.length"
                    >
                      <v-btn
                        v-if="item.cost.length > 0"
                        v-bind="attrs"
                        color="cyan"
                        x-small
                        class="mx-1"
                        v-on="on"
                        @click="openCostListDialog(item)"
                      >
                        {{$t('costs')}}
                      </v-btn>
                    </v-badge>
                  </template>
                  <span>{{ $t('cost') }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.unit="{ item }">
                <v-select
                  v-model="item.unit"
                  :items="unitItems(item)"
                  height="30"
                  dense
                  class="mb-3"
                  outlined
                  return-object
                  item-value="id"
                  item-text="fame"
                  :disabled="(type == 'warehouseHandling' ? true : false)"
                />
              </template>
              <template v-slot:item.counting_one="{ item }">
                <div class="d-flex">
                  <v-text-field
                    v-model="item.counting_one"
                    height="20"
                    dense
                    solo
                    flat
                    :disabled="item.product && item.product.units && item.unit && item.unit.id !== item.product.unit.id"
                    class="mb-3 ms-1 dense"
                    :suffix="(item.product && item.product.unit ? item.product.unit.fame : '')"
                    :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                    :placeholder="$t('count')"
                    type="number"
                  />
                </div>
              </template>
              <template v-slot:item.counting_two="{ item }">
                <div class="d-flex">
                  <v-text-field
                    v-model="item.counting_two"
                    height="20"
                    dense
                    solo
                    flat
                    :disabled="item.product && item.product.units && item.unit && item.unit.id !== item.product.unit.id"
                    class="mb-3 ms-1 dense"
                    :suffix="(item.product && item.product.unit ? item.product.unit.fame : '')"
                    :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                    :placeholder="$t('count')"
                    type="number"
                  />
                </div>
              </template>
              <template v-slot:item.count="{ item }">
                <div class="d-flex">
                  <v-text-field
                    v-show="item.product && item.product.units && item.unit && item.unit.id !== item.product.unit.id"
                    v-model="item.countUnit"
                    height="20"
                    dense
                    solo
                    flat
                    class="mb-3 dense"
                    :suffix="(item.unit ? item.unit.fame : '')"
                    :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                    :placeholder="$t('count')"
                    type="number"
                    @input="convertUnit(item)"
                  />
                  <v-text-field
                    v-model="item.count"
                    height="20"
                    dense
                    solo
                    flat
                    :disabled="item.product && item.product.units && item.unit && item.unit.id !== item.product.unit.id"
                    class="mb-3 ms-1 dense"
                    :suffix="(item.product && item.product.unit ? item.product.unit.fame : '')"
                    :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                    :placeholder="$t('count')"
                    type="number"
                    @input="checkCount(item)"
                  />
                </div>
              </template>
              <template v-slot:item.price="{ item }">
                <money
                  v-model="item.price"
                  :dense="true"
                  :outlined="true"
                  :rules="[feeValidate]"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="mb-3 dense"
                />
              </template>
              <template v-slot:item.expire_date="{ item, index }">
                <v-text-field
                  :id="'expireDate' + index"
                  v-model="item.expire_date"
                  clear-icon="flaticon2-close-cross"
                  outlined
                  dense
                  height="25"
                  class="mb-3"
                  :disabled="type !== 'receipt'"
                  clearable
                />
                <date-picker
                  v-model="item.expire_date"
                  :element="'expireDate' + index"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                />
              </template>
              <template v-slot:item.content="{ item }">
                <v-text-field
                  v-model="item.content"
                  height="20"
                  dense
                  solo
                  flat
                  class="mb-3 dense"
                  :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                  clearable
                  :placeholder="$t('content')"
                />
              </template>
              <template v-slot:item.entrepot="{ item , index }">
                <autocomplete
                  v-model="item.article_entrepot"
                  class="mb-3"
                  type="entrepot"
                  @input="changeEntrepotAtRow(item, index)"
                />
              </template>
            </v-data-table>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col
              cols="12"
              md="3"
              sm="3"
            >
              <file-picker
                ref="refFilePicker"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="entrepot"
                :val="(id && attachments ? attachments : null)"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-divider class="mx-2" />
      <v-card-actions class="pt-0">
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-0"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
          </v-col>
        </v-row>
      </v-card-actions>
      <v-row />
    </v-form>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="costDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="costDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('cost') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <cost
            type="cost"
            :ref-id="selectedItem"
            @input="setCost"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="costListDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="costListDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('costs') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    {{ $t('number') }}
                  </th>
                  <th>
                    {{ $t('cost') }}
                  </th>
                  <th>
                    {{ $t('amount') }}
                  </th>
                  <th>
                    {{ $t('actions') }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(item, i) in costItems.cost"
                  :key="item.id"
                >
                  <td>{{ Number(i) + 1 }}</td>
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ $numberFormat(item.amount) }}</td>
                  <td>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            color="pink"
                            x-small
                            icon
                            v-on="on"
                            @click="remoceCostList(item)"
                          >
                            <v-icon small>
                              mdi-trash-can-outline
                            </v-icon>
                          </v-btn>
                      </template>
                      <span>{{ $t('remove') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Cost from '../cost&income/cost'
  import General from '../../../../Mixins/general'
  import Description from '../../components/general/description/Description'
  import filePicker from '../../components/general/filePicker/index'
  export default {
    name: 'EntrepotIndex',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      filePicker,
      Description,
      Task,
      Cost,
    },
    mixins: [General],
    props: ['input', 'formType', 'refId'],
    data: () => ({
      selected: [],
      costDialog: false,
      attachments: null,
      costManagament: null,
      costItems: null,
      content: null,
      selectedItem: null,
      printDialog: false,
      costListDialog: false,
      deletDialog: false,
      showSelect: false,
      render: false,
      filter: false,
      valid: true,
      detail: null,
      recipientEntrepot: null,
      relations: null,
      productStatus: null,
      productStatusItems: null,
      date: null,
      entrepot: null,
      model: null,
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      type: 'receipt',
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      selectedHeaders: [],
      search: null,
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
    }),
    watch: {
      refId (val, oldVal) {
        // this.items = []
        // this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          // app.getItems()
        }, 1000)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      relations () {
        var app = this
        if (app.relations && app.relations.article && !app.id) {
          app.items = []
          app.items = app.relations.article
          app.items.map(function (value, key) {
            value.cost = []
          })
        } else {
          // app.addRow()
        }
      },
      entrepot (val, oldVal) {
        if (!oldVal && this.items.length === 0 && !this.id) {
          this.addRow()
        }
      },
    },
    computed: {
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'warehouseHandling') {
            if (app.type === 'transferProductStock') {
              if (s.value === 'counting_one' || s.value === 'counting_two' || s.value === 'price' || s.value === 'expire_date') {
              } else {
                return app.selectedHeaders.includes(s)
              }
            } else {
              if (s.value === 'counting_one' || s.value === 'counting_two' || s.value === 'price' || s.value === 'to_product') {
              } else {
                return app.selectedHeaders.includes(s)
              }
            }
          } else {
            if (s.value !== 'to_product') {
              return app.selectedHeaders.includes(s)
            }
          }
        })
      },
    },
    beforeMount () {
      var storage = JSON.parse(localStorage.getItem('token'))
      this.costManagament = storage.init.goodCostManagement.value
      this.type = this.$route.name
      if (this.$route.params.id != null) {
        this.render = false
        this.id = this.$route.params.id
        this.show()
      } else {
        this.render = true
        if (this.entrepot) {
          this.addRow()
        }
      }
    },
    mounted () {
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 10,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 10,
        },
        {
          text: (this.type === 'transferProductStock' ? this.$t('fromProduct') : this.$t('product')),
          sortable: true,
          value: 'product',
          width: 150,
        },
        {
          text: this.$t('toProduct'),
          sortable: true,
          value: 'to_product',
          width: 150,
        },
        {
          text: this.$t('stock'),
          sortable: false,
          value: 'stock',
          width: 50,
        },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'unit',
          width: 80,
        },
        {
          text: this.$t('counting_one'),
          sortable: true,
          value: 'counting_one',
          width: 80,
        },
        {
          text: this.$t('counting_two'),
          sortable: true,
          value: 'counting_two',
          width: 80,
        },
        {
          text: (this.type === 'warehouseHandling' ? this.$t('counting_final') : this.$t('count')),
          sortable: true,
          value: 'count',
          width: 80,
        },
        {
          text: this.$t('price'),
          sortable: true,
          value: 'price',
          width: 120,
        },
        {
          text: this.$t('expireDate'),
          sortable: true,
          value: 'expire_date',
          width: 120,
        },
        {
          text: this.$t('content'),
          sortable: false,
          value: 'content',
          width: 150,
        },
        {
          text: this.$t('entrepot'),
          sortable: false,
          value: 'entrepot',
          width: 150,
        },

      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      this.selectedHeaders = this.headers
      if (this.input) {
        this.model = this.input
      }
      this.loading = false
    },
    methods: {
      changeEntrepotAtRow (item, index) {
      },
      convertUnit (item) {
        item.count = item.countUnit * item.unit.value
      },
      unitItems (item) {
        if (item.product) {
          var units = [item.product.unit]
          if (item.product.units) {
            item.product.units.map(function (value, index) {
              value.unit.value = value.value
              units.push(value.unit)
            })
          }
          if (!item.unit) {
            item.unit = item.product.unit
          }
          // if (!item.unit && this.id) {
          //   if (item.unit2) {
          //     item.unit = item.unit2
          //     item.unit.value = item.unitRate
          //   } else {
          //     item.unit = item.product.unit
          //   }
          // }
          return units
        } else {
          return []
        }
      },
      openCostListDialog (item) {
        this.costItems = item
        this.costListDialog = true
      },
      openCostDialog (item) {
        this.selectedItem = item
        this.costDialog = true
      },
      setCost (val) {
        var index = this.items.indexOf(this.selectedItem)
        this.items[index].cost.push(val)
        this.costDialog = false
        this.selectedItem = null
      },
      addRow () {
        if (this.items.length >= 100) {
          this.snakbarText = this.$t('youCantmoreThan100Record')
          this.snakbarColor = 'blue'
          this.snakbar = true
          return false
        }
        this.items.push({
          product: null,
          cost: [],
          stock: null,
          inEdit: 0,
          outEdit: 0,
          countUnit: null,
          counting_one: null,
          counting_two: null,
          expire_date: null,
          to_product: null,
          count: null,
          price: null,
          unit: null,
          content: null,
          article_entrepot: null,
        })
      },
      remove (item, index1) {
        var index = this.items.indexOf(this.deleteItem)
        var cost = this.deleteItem.cost
        this.items.splice(index, 1)
        this.deletDialog = false
        if (cost.length > 0) {
          this.removeCost(cost)
        }
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'ProductEdit', params: { id: item.id } })
      },
      checkProduct (item, key) {
        if (item.product) {
          var index = this.items.findIndex(x => x.product.id === item.product.id)
          if (!this.id) {
            item.price = item.product.costs
          }
          if (index !== key) {
            // this.$refs['refProduct' + key].clear()
            this.snakbarText = this.$t('alert-product-is-repetitive')
            this.snakbarColor = 'pink'
            this.snakbar = true
          }
        } else {
          this.removeCost(this.items[key].cost)
          this.items[key].cost = []
        }
      },
      checkCount (item) {
        if (this.type !== 'warehouseHandling') {
          if (this.$store.state.negative_inventory === 'no' && this.type === 'remittance' && parseFloat(item.count) > parseFloat(item.product.stock.count)) {
            this.snakbarText = this.$t('alert-inventory-is-not-enough')
            this.snakbarColor = 'pink'
            this.snakbar = true
            item.count = 0
          }
        }
      },
      removegroup () {
        var app = this
        app.selected.map(function (value, key) {
          app.remove(value, key)
        })
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'entrepot', this.$data)
          .then(res => {
            res = res.data
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
            if (app.$refs.refFilePicker !== undefined && app.attachments) {
              app.$refs.refFilePicker.create(res.data.id)
            }
            this.clearForm()
            this.goTo(app.type + 'List')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'entrepot/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.$emit('close', app.$route)
            if (app.$refs.refFilePicker !== undefined) {
              app.$refs.refFilePicker.create(res.data.id)
            }
            app.goTo(app.type + 'List')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'entrepot/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.type = res.type
              app.id = res.id
              app.attachments = res.attachments
              app.entrepot = res.entrepot
              app.recipientEntrepot = res.recipient_entrepot
              app.detail = res.detail
              app.branch = res.branch
              app.relations = res.invoice
              app.items = res.articles
              app.date = res.date
              app.content = res.content
              app.status = (res.last_status ? res.last_status.status : null)
              if (res.tags) {
                app.tag = res.tags
              }
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearForm () {
        this.selected = []
        this.printDialog = false
        this.attachments = null
        this.deletDialog = false
        this.showSelect = false
        this.filter = false
        this.valid = true
        this.costItems = null
        this.detail = null
        this.recipientEntrepot = null
        this.relations = null
        this.productStatus = null
        this.productStatusItems = null
        this.entrepot = null
        this.model = null
        this.from = 1
        this.taskDialog = null
        this.id = null
        this.status = null
        this.tag = null
        this.temp = null
        this.deleteItem = null
        this.sellStatus = null
        this.items = []
        this.sortBy = []
        this.dialog = null
        this.timer = 0
        this.totalItems = 1000
        this.isLoading = false
        this.snakbar = false
        this.taskId = null
        this.snakbarText = null
      },
      remoceCostList (cost) {
        var index = this.costItems.cost.indexOf(cost)
        this.costItems.cost.splice(index, 1)
        this.costListDialog = false
        this.removeCost([cost])
      },
      removeCost (cost) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'CostIncome', {
          params: {
            deleteItems: cost,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

</style>
